module.exports = __webpack_public_path__ + "static/media/brand-refresh-InstagramLogo.f4800211.svg";